import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const ArrowTop: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
      <path d="M8 2.54292e-07L16 7.63251L14.5667 9L8 2.73498L1.43333 9L1.1955e-07 7.63251L8 2.54292e-07Z" fill="#5F6368" />
    </svg>
  </SvgWrapper>
);
